module.exports = __webpack_public_path__ + "static/imagePlaceHolder-1549049fa5d37691165589897d99b487.png";